import { render, staticRenderFns } from "./GridCheckbox.vue?vue&type=template&id=216d6a9d&"
import script from "./GridCheckbox.ts?vue&type=script&lang=js&"
export * from "./GridCheckbox.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports